import { render, staticRenderFns } from "./PolicyProtocol.vue?vue&type=template&id=e849e5da&scoped=true"
import script from "./PolicyProtocol.vue?vue&type=script&lang=ts"
export * from "./PolicyProtocol.vue?vue&type=script&lang=ts"
import style0 from "./PolicyProtocol.vue?vue&type=style&index=0&id=e849e5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e849e5da",
  null
  
)

export default component.exports